<template>
    <section>
        <b-container fluid>
            <b-card title='Филиалы, в которых проходит вакцинация:' class='mt-3'>
                <b-list-group  v-if='vaccinCovidBranches.length > 0'>
                    <b-list-group-item 
                        button
                        v-for='(branch, index) in vaccinCovidBranches' :key='index'
                        class='p-0'
                    >
                        <b-link @click='getInterviewLink(branch)' class='branch-item'>{{branch.Name_branch}}</b-link>
                    </b-list-group-item>
                </b-list-group>
                <!-- <b-card title='Ссылка на опросник: ' class='mt-3' v-if='interviewLink'>
                    <b-link :href="interviewLink" target="_blank">Прямая ссылка</b-link>
                    
                </b-card> -->
                
            </b-card>
     
        </b-container>
    </section>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex"

export default {
    name: "referral-for-interview",
    data() {
        return {

        }
    },
    methods: {
        ...mapActions('covid', [
            'getVaccinCovidBranches', 'getInterviewLink'
        ]),
        ...mapActions('structs', ['getCovidStruct']),

        goToInterview() {
            this.$router.push({ name: 'interview-wizard' }).catch(()=>{});
        },
    },
    computed: {
        ...mapState({
            vaccinCovidBranches: state => state.covid.vaccinCovidBranches,
            interviewLink: state => state.covid.interviewLink,
            struct: state => state.structs.struct
        }),
    }
}
</script>

<style>
.branch-item {
    display: block;
    width: 100%;
    height: 100%;
    padding: 0.75rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/ReferralForInterview.vue